import "../../assets/styles/admin/opd.scss";
import React, { useState, useEffect, useRef } from "react";
import Model from "../../components/modal/model";
import CreateModel from "../../components/modal/createModal";
import HeaderBar from "../../components/header/headerBar";
import SearchButton from "../../components/antd/modal";
import { Input, Button, Row, Col } from "antd";
import { Icon } from "@iconify/react";
import axios from "axios";
import { useHistory } from "react-router";

const CheckMember = () => {
  const [showModal0, setShowModal0] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModalChoose, setShowModalChoose] = useState(false);
  const [search, setSearch] = useState<any>([]);
  const [checkSearch, setCheckSearch] = useState<number>(0);
  const [openModel, setOpenModel] = useState(false);
  const [openModelScan, setOpenModelScan] = useState(false);
  const history = useHistory();

  function toggleModal0() {
    // function 1 finished
    setShowModal0(!showModal0);
  }
  function toggleModal1() {
    setShowModal1(!showModal1);
  }
  function toggleModal2() {
    setShowModal2(!showModal2);
  }
  function toggleModalChoose() {
    setShowModal2(false);
    setShowModalChoose(!showModalChoose);
  }

  const checkCustommer = async () => {
    await axios.get(`/member-opd?search=${search}`).then((res) => {
      let data = res?.data?.data;
      if (data?.length && search?.length > 0) {
        if (data?.length === 1) {
          setCheckSearch(0);
          openModal();
        } else {
          history.push(`/opd/search/${search}`);
        }
      } else {
        setCheckSearch(2);
        openModal();
      }
    });
  };

  const scanCard = async () => {
    setCheckSearch(1);
    setOpenModelScan(!openModelScan);
  };

  const openModal = async () => {
    setOpenModel(!openModel);
  };

  const onSearch = (value: any) => {
    console.log("value", value);
    if (value) {
      setSearch(value);
      checkCustommer();
    }
  };

  useEffect(() => {
    console.log("openModel =>", openModel);
  }, [openModel]);
  return (
    <div>
      <HeaderBar title="OPD" />
      <div className="check-member-page">
        <SearchButton
          show={openModel}
          cancelModal={openModal}
          type={checkSearch}
          path={search}
        />
        <SearchButton
          show={openModelScan}
          cancelModal={scanCard}
          type={checkSearch}
        />
        <Model type={0} show={showModal0} onClose={toggleModal0} />
        <Model type={1} show={showModal1} onClose={toggleModal1} />
        <Model
          type={2}
          show={showModal2}
          onClose={toggleModal2}
          onSubmit={toggleModalChoose}
        />
        <CreateModel show={showModalChoose} onClick={toggleModalChoose} />

        <div className="card-view-opd">
          <div className="title">ค้นหาข้อมูล OPD</div>
          <div className="input-search">
            <Input.Search
              bordered={false}
              placeholder="Search for customer (CN, Name, Mobile, ID Card number)"
              onSearch={onSearch}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
          </div>

          <div className="section-button">
            <Row gutter={[16, 16]}>
              <Col span={12} className="btn-confirm">
                <Button onClick={checkCustommer}>ตรวจสอบข้อมูล CHECK</Button>
              </Col>
              <Col span={12} className="btn-confirm">
                <Button onClick={toggleModalChoose}>
                  <Icon
                    icon="akar-icons:plus"
                    width="1.2rem"
                    height="1.2rem"
                    style={{ marginRight: "5px", marginBottom: "5px" }}
                  />
                  New OPD
                </Button>
              </Col>
            </Row>
          </div>
          <div className="section-scan">
            <div className="line"></div>
            <div className="sub-title">สแกนข้อมูลด้วยบัตรประชาชน</div>
            <div className="line"></div>
          </div>
          <div className="container-footer">
            <div className="container-scan" onClick={scanCard}>
              <Icon icon="bx:scan" width="40px" height="36px" />
              Scan ID Card
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CheckMember;
